<template>
    <div class="tab-mission-wrap section-space--mt_80">
        <div class="row align-items-center">
            <div class="col-lg-6">
                <div class="tab-mission-image">
                    <img src="../../assets/img/trustami/discuss_product_requirements.svg" alt="image" class="img-fluid">
                </div>
            </div>
            <div class="col-lg-6">
                <div class="tab-content-inner">
                    <h4 class="font-weight--light">{{ $t("summ.request") }}</h4>
                    <p class="dec mt-10 mb-10 pre">
                        {"text": "Die Schlichtung der Tarifverhandlungen für das Bauhauptgewerbe ist beendet: Die Tarifpartner haben sich unter Moderation von Schlichter Rainer Schlegel auf ein Tarifpaket geeinigt. Darin enthalten sind Lohnerhöhungen, eine Ost-West-Angleichung........."}
                    </p>

                    <h4 class="font-weight--light">{{ $t("summ.response") }}</h4>
                    <p class="dec mt-10 pre">
                        {"summary": "Die rund 890.000 Beschäftigten der Bauwirtschaft erhalten eine Corona-Prämie und Lohnerhöhungen in drei Schritten. Zusätzlich erhalten die Beschäftigten im Westen Einmalzahlungen in Höhe von 400 Euro zum 1. April 2022 und 450 Euro zum 1. April 2023. Darüber hinaus wurde eine stufenweise Erhöhung der Ausbildungsvergütungen vereinbart. Der Tarifvertrag hat eine Laufzeit von 33 Monaten."}
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'TabContentThree'
}
</script>
